<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="emEmAdmUserGroupResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      with-custom-row-actions-first-column
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #customRowActionsFirstColumn="{row}">
                                    <em-button type="user"
                                               custom-label="成员列表"
                                               class="btn btn-outline-primary btn-sm ml-4 mr-1"
                                               @click="gotoSubUserList(row)">
                                    </em-button>
                                    <em-button type="userSecret"
                                               custom-label="角色列表"
                                               class="btn btn-outline-primary btn-sm"
                                               @click="gotoRoleList(row)">
                                    </em-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
    // Author PanYuRou
    // Date 2023-10-31 16:57:36

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCustomVuexMixin from "@/mixin/em/customVuex";
    import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";

    export default {
        name: "emEmAdmUserGroupListView",
        mixins: [emCommonListMixin, emCustomVuexMixin, emTableCheckedMixin],
        props: {
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        data() {
            return {
                SubUsers: []
            }
        },
        computed: {
            modelName() {
                return this.$_emRouterHelperMixin_entityName
            }
        },
        mounted() {
            if (this.$route.query.hasOwnProperty('userGroupId')) {
                this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.$route.query.userGroupId);
            }
            this.$refs["emListFilter"].doQuery();
        },
        methods: {
            gotoSubUserList(row) {
                this.$router.push("/em/admin/emAclUserList?userGroupId=" + row.id);
            },
            gotoRoleList(row) {
                this.$router.push("/em/admin/userGroup/userGroupRoleList?userGroupId=" + row.id +
                    "&userGroupName=" + row.name);
            },
        }
    };
</script>
